export class CreateRecruitDetail {
  recruitName: string;
  userEmail: string;
  idNumber: string;
  recruiterOid: string;
  supervisorOid: string;
  financialServiceManager: string;
}
